import { tlds } from '../../features/form/constants/tlds';

export const validateEmail = (email: string) => {
	// Check for @ symbol and split
	const parts = email.split('@');
	if (parts.length !== 2) {
		return false;
	}

	const [localPart, domain] = parts;

	// Validate local part (before @)
	if (!localPart) {
		return false;
	}

	// Reject quoted strings
	if (localPart.startsWith('"')) {
		return false;
	}

	// Unquoted local part validation
	// Allowed: a-z A-Z 0-9 and special chars !#$%&'*+-/=?^_`{|}~.
	const localPartRegex = /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~.]+$/;
	if (!localPartRegex.test(localPart)) {
		return false;
	}

	// Dot must not be first or last character
	if (localPart.startsWith('.') || localPart.endsWith('.')) {
		return false;
	}

	// No consecutive dots
	if (localPart.includes('..')) {
		return false;
	}

	// Validate domain
	if (!domain) {
		return false;
	}

	const domainParts = domain.split('.');

	if (!domainParts[0] || domainParts.length === 1 || domainParts.some((part) => !part)) {
		return false;
	}

	const tld = domain.split('.').pop();

	if (!tld) {
		return false;
	}

	return tlds.includes(tld);
};
